import { render, staticRenderFns } from "./farend-container.vue?vue&type=template&id=332da5b4&scoped=true&"
import script from "./farend-container.vue?vue&type=script&lang=js&"
export * from "./farend-container.vue?vue&type=script&lang=js&"
import style0 from "./farend-container.vue?vue&type=style&index=0&id=332da5b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332da5b4",
  null
  
)

export default component.exports